export interface IReportType {
  typeID: number;
  featureID: number | null;
  name: string;
  description: string;
  modifiedDateTime: Date;
  iconName: string; // actually the path to the icon
}
export class ReportType implements IReportType {
    /**
   *
   */
    constructor(name: string) {
        this.name = name;
    }
  public typeID = 0;
  public featureID = 0;
  public name = "";
  public description = "";
  public modifiedDateTime: Date = new Date();
  public iconName = "";
}
